export const DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['title'],
} as const

export const DEFAULT_JOB_TEMPLATES_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  // TOOD: uncomment when BE is ready with sorting
  // ordering: ['name'],
} as const

export const DEFAULT_MESSAGE_TEMPLATES_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['-creation_date'],
} as const
